/**
 * Additional message translations for TicketPanel
 */

export const messageTranslations = {
  ja: {
    // Payment messages
    'payment.cancelled': '決済をキャンセルしました',
    'payment.sessionNotFound': '決済完了後のセッションIDが見つかりません。再読込してください。',
    'payment.pending': '決済は完了しましたが反映待ちです。数秒後に「最新に更新（WEB同期）」を実行してください。',
    'payment.success': '{quantity}件 / {slots}枠の購入を反映しました（30日有効）',
    'payment.verificationFailed': '購入反映の確認に失敗しました。ネットワークを確認して再度お試しください。',
    
    // Login messages
    'login.lineUnauthorizedDomain': 'LINE ログイン失敗: Authorized domains に公開URLを追加してください',
    'login.lineNotEnabled': 'LINE ログイン失敗: Firebase Authentication で LINE (OpenID Connect) プロバイダを有効化してください',
    'login.linePopupBlocked': 'LINE ログイン失敗: ポップアップがブロックまたは途中で閉じられました',
    'login.lineNetworkError': 'LINE ログイン失敗: ネットワークを確認して再試行してください',
    'login.lineProviderNotFound': 'LINE ログイン失敗: Firebase Console で OpenID Connect プロバイダ (oidc.line) を設定してください',
    'login.linePopupError': 'LINE ログイン失敗: ポップアップ/リダイレクト設定を確認してください',
    'login.googleUnauthorizedDomain': 'Google ログイン失敗: Authorized domains に公開URLを追加してください',
    'login.googleNotEnabled': 'Google ログイン失敗: Firebase Authentication で Google プロバイダを有効化してください',
    'login.googlePopupBlocked': 'Google ログイン失敗: ポップアップがブロックまたは途中で閉じられました',
    'login.googleNetworkError': 'Google ログイン失敗: ネットワークを確認して再試行してください',
    'login.googlePopupError': 'Google ログイン失敗: ポップアップ/リダイレクト設定を確認してください',
    'login.anonymousRequired': 'このアプリは ログイン必須です',
    'login.logoutSuccess': 'Googleログインを解除し、初期生成IDに戻しました',
    'login.logoutFailed': 'ログアウトに失敗しました',
    
    // Data management
    'data.deleteAllFailed': 'データ全削除に失敗しました: {error}',
    
    // Ticket messages
    'ticket.loadFailed': 'チケット一覧の読み込みに失敗しました',
    'ticket.nameRequired': 'チケット名を入力してください',
    'ticket.localOnly': 'チケットはこの端末にのみ保存されました（DB書き込み失敗）。まずGoogleログインまたは匿名認証の有効化を確認してください。',
    'ticket.createSuccess': 'チケット「{name}」を作成しました',
    'ticket.createFailed': 'チケット作成に失敗しました: {error}',
    'ticket.deleteLocalOnly': 'チケット削除はローカルのみ反映されました（DB削除権限を確認してください）',
    'ticket.deleteSuccess': 'チケットと関連QRを削除しました',
    'ticket.deleteFailed': 'チケット削除に失敗しました: {error}',
    'ticket.selectRequired': 'チケットを選択してください',
    
    // QR code messages
    'qr.countRequired': 'QRコード枚数を入力してください',
    'qr.generateFailed': 'QRコード生成に失敗しました: {error}',
    'qr.csvDownloadSuccess': 'CSVファイルをダウンロードしました（フリー入力欄付き）',
    'qr.csvDownloadCache': 'CSVファイルをダウンロードしました（ローカルキャッシュ）',
    
    // Maintenance messages
    'maintenance.all': 'システムメンテナンス中です。しばらくお待ちください。',
    'maintenance.excluded': 'システムメンテナンス中です。しばらくお待ちください。',
    'maintenance.error': 'システムエラーが発生しました。しばらくしてから再度お試しください。',
    'qr.noImages': 'ZIP化できるQR画像がありません',
    'qr.pdfCancelled': 'PDF生成をキャンセルしました',
    'qr.noValidCodes': '有効なQRコードがありません',
    'qr.pdfFailed': 'PDF生成に失敗しました: {error}',
    'qr.noGenerated': '生成済みのQRコードがありません',
    'qr.designPdfFailed': 'デザイン付きPDF生成に失敗しました: {error}',
    
    // Entry messages
    'entry.alreadyEntered': 'このQRは既に入場済みです',
    'entry.notFound': '該当するQRが見つかりません',
    'entry.processFailed': '入場処理に失敗しました: {error}',
    'entry.selectTicketFirst': '先にチケットを選択してください',
    
    // External device messages
    'external.updateFailed': '更新に失敗しました: {error}',
    'external.ticketIdCopied': 'チケットIDをコピーしました',
    'external.copyFailed': 'チケットIDのコピーに失敗しました',
    
    // Cache messages
    'cache.clearFailed': 'キャッシュのクリアに失敗しました: {error}',
    'cache.noQRCodes': 'このチケットにはQRコードが生成されていません',
    'cache.loadFailed': 'QRコードの読み込みに失敗しました: {error}',
    'cache.noData': '出力するデータがありません',
    
    // Version checker messages
    'versionChecker.updateAvailable': '新しいバージョンが利用可能です',
    'versionChecker.currentVersion': '現在のバージョン',
    'versionChecker.latestVersion': '最新バージョン',
    'versionChecker.releaseNotes': 'リリースノート',
    'versionChecker.later': '後で',
    'versionChecker.updateNow': '今すぐアップデート',
    'versionChecker.forceUpdateMessage': 'このアップデートは必須です',
    
    // Donation messages
    'donation.title': ' 開発者に投銭',
    'donation.message': 'このアプリを気に入っていただけましたか？\n\n開発を続けるために、コーヒー1杯分の投銭をご検討ください。\n\nあなたのサポートが、より良い機能の開発につながります！',
    'donation.later': '後で',
    'donation.donate': '投銭する',
  },

  
  en: {
    // Payment messages
    'payment.cancelled': 'Payment cancelled',
    'payment.sessionNotFound': 'Session ID not found after payment completion. Please reload.',
    'payment.pending': 'Payment completed but pending reflection. Please execute "Refresh (WEB Sync)" after a few seconds.',
    'payment.success': 'Applied purchase of {quantity} items / {slots} slots (valid for 30 days)',
    'payment.verificationFailed': 'Failed to verify purchase reflection. Please check network and try again.',
    
    // Login messages
    'login.lineUnauthorizedDomain': 'LINE login failed: Add public URL to Authorized domains',
    'login.lineNotEnabled': 'LINE login failed: Enable LINE (OpenID Connect) provider in Firebase Authentication',
    'login.linePopupBlocked': 'LINE login failed: Popup was blocked or closed',
    'login.lineNetworkError': 'LINE login failed: Check network and retry',
    'login.lineProviderNotFound': 'LINE login failed: Configure OpenID Connect provider (oidc.line) in Firebase Console',
    'login.linePopupError': 'LINE login failed: Check popup/redirect settings',
    'login.googleUnauthorizedDomain': 'Google login failed: Add public URL to Authorized domains',
    'login.googleNotEnabled': 'Google login failed: Enable Google provider in Firebase Authentication',
    'login.googlePopupBlocked': 'Google login failed: Popup was blocked or closed',
    'login.googleNetworkError': 'Google login failed: Check network and retry',
    'login.googlePopupError': 'Google login failed: Check popup/redirect settings',
    'login.anonymousRequired': 'This app requires login',
    'login.logoutSuccess': 'Logged out and returned to initial ID',
    'login.logoutFailed': 'Logout failed',
    
    // Data management
    'data.deleteAllFailed': 'Failed to delete all data: {error}',
    
    // Ticket messages
    'ticket.loadFailed': 'Failed to load ticket list',
    'ticket.nameRequired': 'Please enter ticket name',
    'ticket.localOnly': 'Ticket saved locally only (DB write failed). Please check Google login or anonymous auth enablement first.',
    'ticket.createSuccess': 'Created ticket "{name}"',
    'ticket.createFailed': 'Failed to create ticket: {error}',
    'ticket.deleteLocalOnly': 'Ticket deletion reflected locally only (check DB delete permission)',
    'ticket.deleteSuccess': 'Deleted ticket and related QR codes',
    'ticket.deleteFailed': 'Failed to delete ticket: {error}',
    'ticket.selectRequired': 'Please select a ticket',
    
    // QR code messages
    'qr.countRequired': 'Please enter QR code count',
    'qr.generateFailed': 'Failed to generate QR codes: {error}',
    'qr.csvDownloadSuccess': 'Downloaded CSV file (with free text field)',
    'qr.csvDownloadCache': 'Downloaded CSV file (local cache)',
    
    // Maintenance messages
    'maintenance.all': 'System is under maintenance. Please wait.',
    'maintenance.excluded': 'System is under maintenance. Please wait.',
    'maintenance.error': 'System error occurred. Please try again later.',
    
    'qr.noImages': 'No QR images to zip',
    'qr.pdfCancelled': 'PDF generation cancelled',
    'qr.noValidCodes': 'No valid QR codes',
    'qr.pdfFailed': 'Failed to generate PDF: {error}',
    'qr.noGenerated': 'No generated QR codes',
    'qr.designPdfFailed': 'Failed to generate design PDF: {error}',
    
    // Entry messages
    'entry.alreadyEntered': 'This QR code has already been used for entry',
    'entry.notFound': 'QR code not found',
    'entry.processFailed': 'Failed to process entry: {error}',
    'entry.selectTicketFirst': 'Please select a ticket first',
    
    // External device messages
    'external.updateFailed': 'Update failed: {error}',
    'external.ticketIdCopied': 'Ticket ID copied',
    'external.copyFailed': 'Failed to copy ticket ID',
    
    // Cache messages
    'cache.clearFailed': 'Failed to clear cache: {error}',
    'cache.noQRCodes': 'No QR codes generated for this ticket',
    'cache.loadFailed': 'Failed to load QR codes: {error}',
    'cache.noData': 'No data to export',
    
    // Version checker messages
    'versionChecker.updateAvailable': 'New Version Available',
    'versionChecker.currentVersion': 'Current Version',
    'versionChecker.latestVersion': 'Latest Version',
    'versionChecker.releaseNotes': 'Release Notes',
    'versionChecker.later': 'Later',
    'versionChecker.updateNow': 'Update Now',
    'versionChecker.forceUpdateMessage': 'This update is required',
    
    // Donation messages
    'donation.title': 'Tip the Developer',
    'donation.message': 'Do you like this app?\n\nPlease consider tipping the price of a coffee to continue development.\n\nYour support helps create better features!',
    'donation.later': 'Later',
    'donation.donate': 'Tip Now',
  },
  
  ko: {
    // Payment messages
    'payment.cancelled': '결제가 취소되었습니다',
    'payment.sessionNotFound': '결제 완료 후 세션 ID를 찾을 수 없습니다. 다시 로드하세요.',
    'payment.pending': '결제가 완료되었지만 반영 대기 중입니다. 몇 초 후 "최신 업데이트 (웹 동기화)"를 실행하세요.',
    'payment.success': '{quantity}개 / {slots}슬롯 구매가 반영되었습니다 (30일 유효)',
    'payment.verificationFailed': '구매 반영 확인에 실패했습니다. 네트워크를 확인하고 다시 시도하세요.',
    
    // Login messages
    'login.lineUnauthorizedDomain': 'LINE 로그인 실패: Authorized domains에 공개 URL을 추가하세요',
    'login.lineNotEnabled': 'LINE 로그인 실패: Firebase Authentication에서 LINE (OpenID Connect) 제공자를 활성화하세요',
    'login.linePopupBlocked': 'LINE 로그인 실패: 팝업이 차단되었거나 닫혔습니다',
    'login.lineNetworkError': 'LINE 로그인 실패: 네트워크를 확인하고 다시 시도하세요',
    'login.lineProviderNotFound': 'LINE 로그인 실패: Firebase Console에서 OpenID Connect 제공자 (oidc.line)를 설정하세요',
    'login.linePopupError': 'LINE 로그인 실패: 팝업/리디렉션 설정을 확인하세요',
    'login.googleUnauthorizedDomain': 'Google 로그인 실패: Authorized domains에 공개 URL을 추가하세요',
    'login.googleNotEnabled': 'Google 로그인 실패: Firebase Authentication에서 Google 제공자를 활성화하세요',
    'login.googlePopupBlocked': 'Google 로그인 실패: 팝업이 차단되었거나 닫혔습니다',
    'login.googleNetworkError': 'Google 로그인 실패: 네트워크를 확인하고 다시 시도하세요',
    'login.googlePopupError': 'Google 로그인 실패: 팝업/리디렉션 설정을 확인하세요',
    'login.anonymousRequired': '이 앱은 로그인이 필요합니다',
    'login.logoutSuccess': '로그아웃하고 초기 ID로 돌아갔습니다',
    'login.logoutFailed': '로그아웃에 실패했습니다',
    
    // Data management
    'data.deleteAllFailed': '모든 데이터 삭제 실패: {error}',
    
    // Ticket messages
    'ticket.loadFailed': '티켓 목록 로드에 실패했습니다',
    'ticket.nameRequired': '티켓 이름을 입력하세요',
    'ticket.localOnly': '티켓이 로컬에만 저장되었습니다 (DB 쓰기 실패). 먼저 Google 로그인 또는 익명 인증 활성화를 확인하세요.',
    'ticket.createSuccess': '티켓 "{name}"을(를) 생성했습니다',
    'ticket.createFailed': '티켓 생성 실패: {error}',
    'ticket.deleteLocalOnly': '티켓 삭제가 로컬에만 반영되었습니다 (DB 삭제 권한 확인)',
    'ticket.deleteSuccess': '티켓 및 관련 QR 코드를 삭제했습니다',
    'ticket.deleteFailed': '티켓 삭제 실패: {error}',
    'ticket.selectRequired': '티켓을 선택하세요',
    
    // QR code messages
    'qr.countRequired': 'QR 코드 수를 입력하세요',
    'qr.generateFailed': 'QR 코드 생성 실패: {error}',
    'qr.csvDownloadSuccess': 'CSV 파일을 다운로드했습니다 (자유 입력 필드 포함)',
    'qr.csvDownloadCache': 'CSV 파일을 다운로드했습니다 (로컬 캐시)',
    'qr.noImages': 'ZIP으로 만들 QR 이미지가 없습니다',
    'qr.pdfCancelled': 'PDF 생성이 취소되었습니다',
    'qr.noValidCodes': '유효한 QR 코드가 없습니다',
    'qr.pdfFailed': 'PDF 생성 실패: {error}',
    'qr.noGenerated': '생성된 QR 코드가 없습니다',
    'qr.designPdfFailed': '디자인 PDF 생성 실패: {error}',
    
    // Entry messages
    'entry.alreadyEntered': '이 QR 코드는 이미 입장에 사용되었습니다',
    'entry.notFound': 'QR 코드를 찾을 수 없습니다',
    'entry.processFailed': '입장 처리 실패: {error}',
    'entry.selectTicketFirst': '먼저 티켓을 선택하세요',
    
    // External device messages
    'external.updateFailed': '업데이트 실패: {error}',
    'external.ticketIdCopied': '티켓 ID가 복사되었습니다',
    'external.copyFailed': '티켓 ID 복사 실패',
    
    // Cache messages
    'cache.clearFailed': '캐시 지우기 실패: {error}',
    'cache.noQRCodes': '이 티켓에 생성된 QR 코드가 없습니다',
    'cache.loadFailed': 'QR 코드 로드 실패: {error}',
    'cache.noData': '내보낼 데이터가 없습니다',
    
    // Version checker messages
    'versionChecker.updateAvailable': '새 버전 사용 가능',
    'versionChecker.currentVersion': '현재 버전',
    'versionChecker.latestVersion': '최신 버전',
    'versionChecker.releaseNotes': '릴리스 노트',
    'versionChecker.later': '나중에',
    'versionChecker.updateNow': '지금 업데이트',
    'versionChecker.forceUpdateMessage': '이 업데이트는 필수입니다',
    
    // Donation messages
    'donation.title': '개발자 후원',
    'donation.message': '이 앱이 마음에 드시나요?\n\n개발을 계속하기 위해 커피 한 잔 값의 후원을 고려해 주세요.\n\n여러분의 지원이 더 나은 기능 개발로 이어집니다!',
    'donation.later': '나중에',
    'donation.donate': '후원하기',
  },
  
  zh: {
    // Payment messages
    'payment.cancelled': '支付已取消',
    'payment.sessionNotFound': '支付完成后未找到会话ID。请重新加载。',
    'payment.pending': '支付已完成但等待反映。请在几秒后执行"刷新（网页同步）"。',
    'payment.success': '已应用购买 {quantity} 项 / {slots} 槽位（30天有效）',
    'payment.verificationFailed': '验证购买反映失败。请检查网络并重试。',
    
    // Login messages
    'login.lineUnauthorizedDomain': 'LINE 登录失败：将公共URL添加到授权域',
    'login.lineNotEnabled': 'LINE 登录失败：在Firebase Authentication中启用LINE (OpenID Connect) 提供商',
    'login.linePopupBlocked': 'LINE 登录失败：弹窗被阻止或关闭',
    'login.lineNetworkError': 'LINE 登录失败：检查网络并重试',
    'login.lineProviderNotFound': 'LINE 登录失败：在Firebase Console中配置OpenID Connect提供商 (oidc.line)',
    'login.linePopupError': 'LINE 登录失败：检查弹窗/重定向设置',
    'login.googleUnauthorizedDomain': 'Google 登录失败：将公共URL添加到授权域',
    'login.googleNotEnabled': 'Google 登录失败：在Firebase Authentication中启用Google提供商',
    'login.googlePopupBlocked': 'Google 登录失败：弹窗被阻止或关闭',
    'login.googleNetworkError': 'Google 登录失败：检查网络并重试',
    'login.googlePopupError': 'Google 登录失败：检查弹窗/重定向设置',
    'login.anonymousRequired': '此应用需要登录',
    'login.logoutSuccess': '已登出并返回初始ID',
    'login.logoutFailed': '登出失败',
    
    // Data management
    'data.deleteAllFailed': '删除所有数据失败：{error}',
    
    // Ticket messages
    'ticket.loadFailed': '加载票券列表失败',
    'ticket.nameRequired': '请输入票券名称',
    'ticket.localOnly': '票券仅保存在本地（DB写入失败）。请先检查Google登录或匿名认证启用。',
    'ticket.createSuccess': '已创建票券 "{name}"',
    'ticket.createFailed': '创建票券失败：{error}',
    'ticket.deleteLocalOnly': '票券删除仅在本地反映（检查DB删除权限）',
    'ticket.deleteSuccess': '已删除票券及相关二维码',
    'ticket.deleteFailed': '删除票券失败：{error}',
    'ticket.selectRequired': '请选择票券',
    
    // QR code messages
    'qr.countRequired': '请输入二维码数量',
    'qr.generateFailed': '生成二维码失败：{error}',
    'qr.csvDownloadSuccess': '已下载CSV文件（含自由文本字段）',
    'qr.csvDownloadCache': '已下载CSV文件（本地缓存）',
    'qr.noImages': '没有可压缩的二维码图片',
    'qr.pdfCancelled': 'PDF生成已取消',
    'qr.noValidCodes': '没有有效的二维码',
    'qr.pdfFailed': 'PDF生成失败：{error}',
    'qr.noGenerated': '没有生成的二维码',
    'qr.designPdfFailed': '设计PDF生成失败：{error}',
    
    // Entry messages
    'entry.alreadyEntered': '此二维码已用于入场',
    'entry.notFound': '未找到二维码',
    'entry.processFailed': '处理入场失败：{error}',
    'entry.selectTicketFirst': '请先选择票券',
    
    // External device messages
    'external.updateFailed': '更新失败：{error}',
    'external.ticketIdCopied': '已复制票券ID',
    'external.copyFailed': '复制票券ID失败',
    
    // Cache messages
    'cache.clearFailed': '清除缓存失败：{error}',
    'cache.noQRCodes': '此票券没有生成的二维码',
    'cache.loadFailed': '加载二维码失败：{error}',
    'cache.noData': '没有要导出的数据',
    
    // Version checker messages
    'versionChecker.updateAvailable': '有新版本可用',
    'versionChecker.currentVersion': '当前版本',
    'versionChecker.latestVersion': '最新版本',
    'versionChecker.releaseNotes': '更新说明',
    'versionChecker.later': '稍后',
    'versionChecker.updateNow': '立即更新',
    'versionChecker.forceUpdateMessage': '此更新为必需更新',
    
    // Donation messages
    'donation.title': '打赏开发者',
    'donation.message': '您喜欢这个应用吗？\n\n请考虑打赏一杯咖啡的价格以继续开发。\n\n您的支持将帮助创建更好的功能！',
    'donation.later': '稍后',
    'donation.donate': '打赏',
  }
};

// Commercial transaction law information
messageTranslations.ja['commercialLaw.title'] = '特定商取引法に基づく表記';
messageTranslations.ja['commercialLaw.businessName'] = '法人名・商号';
messageTranslations.ja['commercialLaw.businessNameDesc'] = '法人の場合: お客様の登録商号。個人の場合: お客様の登録商号または正式な氏名（「請求があった場合は遅滞なく開示します」と記載して省略可能）';
messageTranslations.ja['commercialLaw.address'] = '住所';
messageTranslations.ja['commercialLaw.addressDesc'] = '事業所の所在地（登記簿上の所在地）。個人事業主の場合は「請求があった場合には速やかに開示いたします」と記載可能';
messageTranslations.ja['commercialLaw.phone'] = '電話番号';
messageTranslations.ja['commercialLaw.phoneDesc'] = '顧客が日本語で問い合わせができる電話番号。個人事業主の場合は「請求があった場合には速やかに開示いたします」と記載可能';
messageTranslations.ja['commercialLaw.businessHours'] = '営業時間';
messageTranslations.ja['commercialLaw.email'] = 'メールアドレス';
messageTranslations.ja['commercialLaw.emailDesc'] = '顧客が問い合わせできるメールアドレス';
messageTranslations.ja['commercialLaw.representative'] = '運営責任者';
messageTranslations.ja['commercialLaw.representativeDesc'] = '組織またはビジネスの代表、または指定された会社の代表者';
messageTranslations.ja['commercialLaw.additionalFees'] = '追加手数料';
messageTranslations.ja['commercialLaw.additionalFeesDesc'] = '商品またはサービスの代金以外に、顧客が負担する可能性のあるすべての手数料（配送料、処理手数料など）に関する情報';
messageTranslations.ja['commercialLaw.shippingFee'] = '1箱あたり一律 1,000円の配送料';
messageTranslations.ja['commercialLaw.convenienceFee'] = 'コンビニ決済の取引手数料: 100円';
messageTranslations.ja['commercialLaw.returnPolicy'] = '交換および返品に関するポリシー';
messageTranslations.ja['commercialLaw.returnPolicyDesc'] = 'すべてのStripeユーザーは、公平な返金ポリシーを維持する必要があります。説明は以下の2点を含めてください: 1つは不良品の場合の対応方法、もう1つは通常の非不良品の場合の対応方法です';
messageTranslations.ja['commercialLaw.returnBeforeShipping'] = '配送前の商品の場合: ウェブサイトのキャンセルボタンを押して注文をキャンセルできます';
messageTranslations.ja['commercialLaw.returnAfterShipping'] = '発送後の商品の場合: 未開封の商品については、商品到着後10日以内にカスタマーサポートセンター（電話番号を挿入）にご連絡いただいた場合に限り、返金または交換が可能です。開封後の返品や交換は受け付けておりません';
messageTranslations.ja['commercialLaw.returnDefective'] = '不良品・サービスの返品・交換: カスタマーサポートセンター（電話番号を挿入）にお問い合わせください。弊社が送料を負担して返金するか、新しい製品と交換いたします';
messageTranslations.ja['commercialLaw.deliveryTime'] = '配達時間';
messageTranslations.ja['commercialLaw.deliveryTimeDesc'] = '顧客が注文を完了してから、商品が届けられる時期やサービスが提供される時期';
messageTranslations.ja['commercialLaw.deliveryTimeDetails'] = '注文は3～5営業日以内に処理されます。商品は14日以内に受け取る必要があり、注文後すぐに利用可能です';
messageTranslations.ja['commercialLaw.paymentMethods'] = '利用可能な決済手段';
messageTranslations.ja['commercialLaw.paymentMethodsDesc'] = '顧客がサービス料金の支払いに利用できるすべての決済手段';
messageTranslations.ja['commercialLaw.paymentMethodsDetails'] = 'クレジットカードまたは国内の銀行振込';
messageTranslations.ja['commercialLaw.paymentPeriod'] = '決済期間';
messageTranslations.ja['commercialLaw.paymentPeriodDesc'] = '顧客が支払いを行うと予想される期間';
messageTranslations.ja['commercialLaw.paymentPeriodDetails'] = 'クレジットカード決済はただちに処理されますが、国内の銀行振込は注文から3日以内に送金する必要があります';
messageTranslations.ja['commercialLaw.price'] = '価格';
messageTranslations.ja['commercialLaw.priceDesc'] = '商品またはサービスの販売価格（消費税を含む）';
messageTranslations.ja['commercialLaw.priceDetails'] = '4,000円 各商品ページに記載の金額';

messageTranslations.en['commercialLaw.title'] = 'Commercial Transaction Law Information';
messageTranslations.en['commercialLaw.businessName'] = 'Business Name / Registered Trade Name';
messageTranslations.en['commercialLaw.businessNameDesc'] = 'For corporations: Your registered trade name. For individuals: Your registered trade name or legal name (may be omitted with statement "Will be disclosed promptly upon request")';
messageTranslations.en['commercialLaw.address'] = 'Address';
messageTranslations.en['commercialLaw.addressDesc'] = 'Business location (registered address). For sole proprietors: May state "Will be disclosed promptly upon request"';
messageTranslations.en['commercialLaw.phone'] = 'Phone Number';
messageTranslations.en['commercialLaw.phoneDesc'] = 'Phone number for customer inquiries in Japanese. For sole proprietors: May state "Will be disclosed promptly upon request"';
messageTranslations.en['commercialLaw.businessHours'] = 'Business Hours';
messageTranslations.en['commercialLaw.email'] = 'Email Address';
messageTranslations.en['commercialLaw.emailDesc'] = 'Email address for customer inquiries';
messageTranslations.en['commercialLaw.representative'] = 'Operating Representative';
messageTranslations.en['commercialLaw.representativeDesc'] = 'Representative of the organization or business, or designated company representative';
messageTranslations.en['commercialLaw.additionalFees'] = 'Additional Fees';
messageTranslations.en['commercialLaw.additionalFeesDesc'] = 'Information about all fees that customers may incur in addition to the price of goods or services (shipping fees, processing fees, etc.)';
messageTranslations.en['commercialLaw.shippingFee'] = 'Flat shipping fee per box: ¥1,000';
messageTranslations.en['commercialLaw.convenienceFee'] = 'Convenience store payment transaction fee: ¥100';
messageTranslations.en['commercialLaw.returnPolicy'] = 'Exchange and Return Policy';
messageTranslations.en['commercialLaw.returnPolicyDesc'] = 'All Stripe users must maintain a fair refund policy. Include explanations for: 1) Handling defective products, and 2) Handling non-defective products';
messageTranslations.en['commercialLaw.returnBeforeShipping'] = 'For items before shipping: You can cancel your order by pressing the cancel button on the website';
messageTranslations.en['commercialLaw.returnAfterShipping'] = 'For items after shipping: Refunds or exchanges are only possible for unopened items within 10 days of receipt by contacting customer support center (insert phone number). Returns or exchanges after opening are not accepted';
messageTranslations.en['commercialLaw.returnDefective'] = 'Defective items/service returns/exchanges: Please contact customer support center (insert phone number). We will cover shipping costs for refunds or exchange with new products';
messageTranslations.en['commercialLaw.deliveryTime'] = 'Delivery Time';
messageTranslations.en['commercialLaw.deliveryTimeDesc'] = 'Timeframe from when customer completes order to when goods are delivered or service is provided';
messageTranslations.en['commercialLaw.deliveryTimeDetails'] = 'Orders are processed within 3-5 business days. Items must be received within 14 days and are available immediately after ordering';
messageTranslations.en['commercialLaw.paymentMethods'] = 'Available Payment Methods';
messageTranslations.en['commercialLaw.paymentMethodsDesc'] = 'All payment methods available for customers to pay service fees';
messageTranslations.en['commercialLaw.paymentMethodsDetails'] = 'Credit card or domestic bank transfer';
messageTranslations.en['commercialLaw.paymentPeriod'] = 'Payment Period';
messageTranslations.en['commercialLaw.paymentPeriodDesc'] = 'Expected period for customers to make payments';
messageTranslations.en['commercialLaw.paymentPeriodDetails'] = 'Credit card payments are processed immediately, but domestic bank transfers must be sent within 3 days of order';
messageTranslations.en['commercialLaw.price'] = 'Price';
messageTranslations.en['commercialLaw.priceDesc'] = 'Sales price of goods or services (including consumption tax)';
messageTranslations.en['commercialLaw.priceDetails'] = '¥4,000 Amount listed on each product page';

messageTranslations.ko['commercialLaw.title'] = '특정 상거래법에 따른 표시';
messageTranslations.ko['commercialLaw.businessName'] = '법인명·상호';
messageTranslations.ko['commercialLaw.businessNameDesc'] = '법인의 경우: 고객의 등록 상호. 개인의 경우: 고객의 등록 상호 또는 정식 성명 ("요청 시 지체 없이 공개합니다"라고 기재하여 생략 가능)';
messageTranslations.ko['commercialLaw.address'] = '주소';
messageTranslations.ko['commercialLaw.addressDesc'] = '사업소 소재지 (등기부상 소재지). 개인 사업자의 경우 "요청 시 신속히 공개하겠습니다"라고 기재 가능';
messageTranslations.ko['commercialLaw.phone'] = '전화번호';
messageTranslations.ko['commercialLaw.phoneDesc'] = '고객이 일본어로 문의할 수 있는 전화번호. 개인 사업자의 경우 "요청 시 신속히 공개하겠습니다"라고 기재 가능';
messageTranslations.ko['commercialLaw.businessHours'] = '영업 시간';
messageTranslations.ko['commercialLaw.email'] = '이메일 주소';
messageTranslations.ko['commercialLaw.emailDesc'] = '고객이 문의할 수 있는 이메일 주소';
messageTranslations.ko['commercialLaw.representative'] = '운영 책임자';
messageTranslations.ko['commercialLaw.representativeDesc'] = '조직 또는 비즈니스의 대표, 또는 지정된 회사 대표자';
messageTranslations.ko['commercialLaw.additionalFees'] = '추가 수수료';
messageTranslations.ko['commercialLaw.additionalFeesDesc'] = '상품 또는 서비스 대금 외에 고객이 부담할 수 있는 모든 수수료 (배송료, 처리 수수료 등)에 관한 정보';
messageTranslations.ko['commercialLaw.shippingFee'] = '박스당 일괄 배송료: ¥1,000';
messageTranslations.ko['commercialLaw.convenienceFee'] = '편의점 결제 거래 수수료: ¥100';
messageTranslations.ko['commercialLaw.returnPolicy'] = '교환 및 반품 정책';
messageTranslations.ko['commercialLaw.returnPolicyDesc'] = '모든 Stripe 사용자는 공정한 환불 정책을 유지해야 합니다. 다음 2가지에 대한 설명을 포함하세요: 1) 불량품 처리 방법, 2) 일반 비불량품 처리 방법';
messageTranslations.ko['commercialLaw.returnBeforeShipping'] = '배송 전 상품의 경우: 웹사이트의 취소 버튼을 눌러 주문을 취소할 수 있습니다';
messageTranslations.ko['commercialLaw.returnAfterShipping'] = '배송 후 상품의 경우: 개봉하지 않은 상품에 한해 상품 수령 후 10일 이내에 고객 지원 센터 (전화번호 삽입)에 연락한 경우에만 환불 또는 교환이 가능합니다. 개봉 후 반품이나 교환은 받지 않습니다';
messageTranslations.ko['commercialLaw.returnDefective'] = '불량품·서비스 반품·교환: 고객 지원 센터 (전화번호 삽입)에 문의하세요. 저희가 배송비를 부담하여 환불하거나 새 제품과 교환해 드립니다';
messageTranslations.ko['commercialLaw.deliveryTime'] = '배송 시간';
messageTranslations.ko['commercialLaw.deliveryTimeDesc'] = '고객이 주문을 완료한 후 상품이 배달되거나 서비스가 제공되는 시기';
messageTranslations.ko['commercialLaw.deliveryTimeDetails'] = '주문은 3~5 영업일 이내에 처리됩니다. 상품은 14일 이내에 수령해야 하며 주문 후 즉시 이용 가능��니다';
messageTranslations.ko['commercialLaw.paymentMethods'] = '이용 가능한 결제 수단';
messageTranslations.ko['commercialLaw.paymentMethodsDesc'] = '고객이 서비스 요금 지불에 이용할 수 있는 모든 결제 수단';
messageTranslations.ko['commercialLaw.paymentMethodsDetails'] = '신용카드 또는 국내 은행 송금';
messageTranslations.ko['commercialLaw.paymentPeriod'] = '결제 기간';
messageTranslations.ko['commercialLaw.paymentPeriodDesc'] = '고객이 지불을 할 것으로 예상되는 기간';
messageTranslations.ko['commercialLaw.paymentPeriodDetails'] = '신용카드 결제는 즉시 처리되지만 국내 은행 송금은 주문 후 3일 이내에 송금해야 합니다';
messageTranslations.ko['commercialLaw.price'] = '가격';
messageTranslations.ko['commercialLaw.priceDesc'] = '상품 또는 서비스의 판매 가격 (소비세 포함)';
messageTranslations.ko['commercialLaw.priceDetails'] = '¥4,000 각 상품 페이지에 기재된 금액';

messageTranslations.zh['commercialLaw.title'] = '特定商业交易法信息';
messageTranslations.zh['commercialLaw.businessName'] = '法人名称/商号';
messageTranslations.zh['commercialLaw.businessNameDesc'] = '法人：您的注册商号。个人：您的注册商号或法定姓名（可省略并注明"请求时将及时披露"）';
messageTranslations.zh['commercialLaw.address'] = '地址';
messageTranslations.zh['commercialLaw.addressDesc'] = '营业场所所在地（登记地址）。个人经营者：可注明"请求时将及时披露"';
messageTranslations.zh['commercialLaw.phone'] = '电话号码';
messageTranslations.zh['commercialLaw.phoneDesc'] = '客户可用日语咨询的电话号码。个人经营者：可注明"请求时将及时披露"';
messageTranslations.zh['commercialLaw.businessHours'] = '营业时间';
messageTranslations.zh['commercialLaw.email'] = '电子邮件地址';
messageTranslations.zh['commercialLaw.emailDesc'] = '客户可咨询的电子邮件地址';
messageTranslations.zh['commercialLaw.representative'] = '运营负责人';
messageTranslations.zh['commercialLaw.representativeDesc'] = '组织或业务的代表，或指定的公司代表';
messageTranslations.zh['commercialLaw.additionalFees'] = '附加费用';
messageTranslations.zh['commercialLaw.additionalFeesDesc'] = '除商品或服务价格外客户可能承担的所有费用信息（运费、处理费等）';
messageTranslations.zh['commercialLaw.shippingFee'] = '每箱统一运费：¥1,000';
messageTranslations.zh['commercialLaw.convenienceFee'] = '便利店支付交易费：¥100';
messageTranslations.zh['commercialLaw.returnPolicy'] = '退换货政策';
messageTranslations.zh['commercialLaw.returnPolicyDesc'] = '所有Stripe用户必须保持公平的退款政策。包括以下两点的说明：1) 处理有缺陷产品的方法，2) 处理非缺陷产品的方法';
messageTranslations.zh['commercialLaw.returnBeforeShipping'] = '发货前商品：可通过网站取消按钮取消订单';
messageTranslations.zh['commercialLaw.returnAfterShipping'] = '发货后商品：仅限未开封商品在收货后10天内联系客服中心（插入电话号码）可退款或换货。开封后退货或换货不接受';
messageTranslations.zh['commercialLaw.returnDefective'] = '有缺陷商品/服务退换货：请联系客服中心（插入电话号码）。我们将承担运费进行退款或更换新产品';
messageTranslations.zh['commercialLaw.deliveryTime'] = '配送时间';
messageTranslations.zh['commercialLaw.deliveryTimeDesc'] = '从客户完成订单到商品送达或服务提供的时间';
messageTranslations.zh['commercialLaw.deliveryTimeDetails'] = '订单在3-5个工作日内处理。商品需在14天内收到，订购后立即可用';
messageTranslations.zh['commercialLaw.paymentMethods'] = '可用支付方式';
messageTranslations.zh['commercialLaw.paymentMethodsDesc'] = '客户可用于支付服务费的所有支付方式';
messageTranslations.zh['commercialLaw.paymentMethodsDetails'] = '信用卡或国内银行转账';
messageTranslations.zh['commercialLaw.paymentPeriod'] = '支付期限';
messageTranslations.zh['commercialLaw.paymentPeriodDesc'] = '客户预计进行支付的期限';
messageTranslations.zh['commercialLaw.paymentPeriodDetails'] = '信用卡支付立即处理，但国内银行转账需在订单后3天内汇款';
messageTranslations.zh['commercialLaw.price'] = '价格';
messageTranslations.zh['commercialLaw.priceDesc'] = '商品或服务的销售价格（含消费税）';
messageTranslations.zh['commercialLaw.priceDetails'] = '¥4,000 各商品页面列出的金额';
